export default "__VITE_ASSET__CJvuUyAP__"